import React from 'react'
import {
    Box,
    Divider,
    IconButton,
    Tooltip,
    Typography,
} from '@mui/material'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

const iconButtonSx = {
    borderRadius: 0,
    padding: '2px 4px',
}

const iconSx = disabled => ({
    fontSize: 13,
    color: disabled ? 'text.disabled' : 'text.secondary',
})

const MatchNavigator = ({ current, total, onPrev, onNext, disabled }) => {
    const prevButton = (
        <IconButton
            size="small"
            disabled={disabled}
            onClick={onPrev}
            aria-label="previous match"
            sx={iconButtonSx}
        >
            <KeyboardArrowUpIcon sx={iconSx(disabled)} />
        </IconButton>
    )

    const nextButton = (
        <IconButton
            size="small"
            disabled={disabled}
            onClick={onNext}
            aria-label="next match"
            sx={iconButtonSx}
        >
            <KeyboardArrowDownIcon sx={iconSx(disabled)} />
        </IconButton>
    )

    return (
        <Box
            data-testid="match-navigator"
            sx={{
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <Typography
                variant="caption"
                sx={{
                    fontVariantNumeric: 'tabular-nums',
                    color: 'text.secondary',
                    fontSize: 12,
                    lineHeight: 1,
                }}
            >
                {current}
                <Box
                    component="span"
                    sx={{ color: 'text.disabled', mx: 0.5 }}
                >
                    /
                </Box>
                {total}
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    border: 1,
                    borderColor: 'divider',
                    borderRadius: 1,
                    ml: 1,
                    overflow: 'hidden',
                }}
            >
                {disabled ? (
                    prevButton
                ) : (
                    <Tooltip title="Previous match" arrow={false}>
                        {prevButton}
                    </Tooltip>
                )}
                <Divider orientation="vertical" flexItem />
                {disabled ? (
                    nextButton
                ) : (
                    <Tooltip title="Next match" arrow={false}>
                        {nextButton}
                    </Tooltip>
                )}
            </Box>
        </Box>
    )
}

export default MatchNavigator
